import { useState } from 'react';
import { useDispatch } from "react-redux";
import MessageTree from './MessageTree';
import CreateField from '../../molecules/fields/CreateField';
import EditField from '../../molecules/fields/EditField';
import RenameEventType from './RenameEventType';
import DeleteFieldAlert from '../../molecules/alerts/DeleteFieldAlert';
import { Grid } from "@material-ui/core";
import { makeStyles } from '@material-ui/core/styles';
import ReusedFieldWarning from '../../atoms/warnings/ReusedFieldWarning';
import { handleSnackBar } from '../../../store/global/actions';

const useStyles = makeStyles({
    fieldForm: {
        marginLeft: -12
    }
});

export default function EditEventType({ parent, item, setMessage }) {

    const classes = useStyles();
    const dispatch = useDispatch();
    const [action, setAction] = useState({});
    const [msgReusedEvents, setMsgReusedEvents] = useState([]);
    const [shouldRerenderMessageTree, setShouldRerenderMessageTree] = useState(false); // State variable to trigger MessageTree rerender


    const onActionCompletion = (type, action) => {

        if (action != undefined) {
            switch (action) {
                case 'edit':
                    dispatch(handleSnackBar({ open: true, message: `${type} updated`, severity: 'success' }));
                    break;

                case 'add':
                    dispatch(handleSnackBar({ open: true, message: `${type} created`, severity: 'success' }));
                    break;

                case 'delete':
                    dispatch(handleSnackBar({ open: true, message: `${type} deleted`, severity: 'success' }));
                    break;

            }
        }
        setShouldRerenderMessageTree(prevState => !prevState); // Toggle state to trigger MessageTree rerender
        setAction({});
    }


    return (
        <Grid container direction={"row"} spacing={2}>
            {msgReusedEvents.length > 1 &&
                <Grid item xs={12}> <ReusedFieldWarning events={msgReusedEvents} /> </Grid>
            }

            <Grid item xs={6}>
                <MessageTree parent={parent} setAction={setAction} setMsgReusedEvents={setMsgReusedEvents} item={item} shouldRerender={shouldRerenderMessageTree} />
            </Grid>

            {(Object.keys(action).length === 0 || action.action === 'rename_event_type') && <Grid item xs={6} style={{ marginTop: '22px' }}>
                <RenameEventType event={item} item={item} setNewMessage={setMessage} />
            </Grid>}

            {action.action == 'create_field' && <Grid item xs={6} className={classes.fieldForm}>
                <CreateField isEventType onClose={() => setAction({})} onCompletion={onActionCompletion} section={action} />
            </Grid>}

            {action.action == 'edit_field' && <Grid item xs={6} className={classes.fieldForm}>
                <EditField isEventType key={action.id} onClose={() => setAction({})} onCompletion={onActionCompletion} fields={action} />
            </Grid>}

            {action.action == 'delete_field' &&
                <   DeleteFieldAlert onCompletion={onActionCompletion} id={action.id} onClose={() => setAction({})} />
            }

        </Grid >
    )
}
